// extracted by mini-css-extract-plugin
export var actionButton = "_9f-1";
export var actionButtons = "_9f-2";
export var actions = "_9f-0";
export var aiUnread = "_9f-10";
export var alignCenter = "_9f-h";
export var backWrapper = "_9f-3";
export var cellContainer = "_9f-4";
export var checkboxContainer = "_9f-5";
export var contentContainer = "_9f-6";
export var contentHeader = "_9f-8";
export var conversationsTableWrapper = "_9f-s";
export var draftReplyBadgeContainer = "_9f-m";
export var dropdownItem = "_9f-b";
export var dropdownItemsContainer = "_9f-a";
export var dropdownTitle = "_9f-c";
export var errorIcon = "_9f-7";
export var filter = "_9f-d";
export var gray = "_9f-i";
export var headerActionButtons = "_9f-e";
export var headerCheckboxContainer = "_9f-f";
export var icon = "_9f-j";
export var menuContainer = "_9f-k";
export var noMoreTicketsIcon = "_9f-12";
export var noMoreTicketsSubText = "_9f-13";
export var oneLine = "_9f-l";
export var optionsButton = "_9f-n";
export var plus = "_9f-o";
export var portalButtonsWrapper = "_9f-g";
export var red = "_9f-p";
export var scrolledTop = "_9f-9";
export var search = "_9f-q";
export var selectedConversationsCount = "_9f-r";
export var spinner = "_9f-t";
export var strong = "_9f-u";
export var summaryCell = "_9f-v";
export var tableContainer = "_9f-11";
export var tagContainer = "_9f-w";
export var threeDots = "_9f-x";
export var twoLines = "_9f-y";
export var unread = "_9f-z";